import { Boilerplate } from "@/components/landing/Boilerplate";
import { Comparsion } from "@/components/landing/Comparsion";
import { Cta } from "@/components/landing/Cta";
import { FAQ } from "@/components/landing/FAQ";
import { Features } from "@/components/landing/Features";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Problems } from "@/components/landing/Problems";
import { ScrollToTop } from "@/components/landing/ScrollToTop";
import { Templates } from "@/components/landing/Templates";
import { Testimonials } from "@/components/landing/Testimonials";
import { DynamicVideo } from "@/components/landing/DynamicVideo";

export const LandingPage = () => {
  return (
    <>
      <Hero />
      <div className="pt-15 md:pt-0 pb-15 md:pb-40">
        <DynamicVideo />
      </div>
      <Problems />
      <div className="flex flex-col gap-20 md:gap-30 pt-20 mb-20">
        <HowItWorks />
        <Features />
        <Boilerplate landing />
        <Templates landing />
        <Testimonials landing />
        <Comparsion />
        <Cta />
        <FAQ limit={5} />
        <ScrollToTop />
      </div>
    </>
  );
};
